import { Injectable } from '@angular/core';
import { EntityState, EntityStore } from '@examdojo/state';
import { ClassStudentStatsStoreModel } from './class-student-stats.model';

export type ClassStudentStatsState = EntityState<ClassStudentStatsStoreModel>;

@Injectable({ providedIn: 'root' })
export class ClassStudentStatsStore extends EntityStore<ClassStudentStatsState, ClassStudentStatsStoreModel, 'id'> {
  constructor() {
    super({
      name: 'class-student-stats',
      idKey: 'id',
    });
  }
}
